import { render, staticRenderFns } from "./required-editor.vue?vue&type=template&id=7464dd76&scoped=true&"
import script from "./required-editor.vue?vue&type=script&lang=js&"
export * from "./required-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7464dd76",
  null
  
)

export default component.exports